import { render, staticRenderFns } from "./Exams.vue?vue&type=template&id=a29fd50e&scoped=true&"
import script from "./Exams.vue?vue&type=script&lang=js&"
export * from "./Exams.vue?vue&type=script&lang=js&"
import style0 from "./Exams.vue?vue&type=style&index=0&id=a29fd50e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a29fd50e",
  null
  
)

export default component.exports